module.exports = __webpack_public_path__ + "img/play_circle_filled_white.8d554250.svg";